import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
} from "@mui/material";
import {
  StyledTableCellValueTemplate,
  StyledTableCellLabelTemplate,
  LabelTemplate,
  StyledTableRowTemplate,
  StyledTableContainer,
} from "../../styles/table";
import { Employee } from "../../../types/processTypes";

import { format, isValid } from "date-fns";
import { tt } from "../../../../../data/langUtility";

type DateLike = Date | string | undefined | null;

const safeFormatDate = (value: DateLike, dateFormat: string): string => {
  if (value == null || value === "") return "";
  const d = new Date(value);
  return isValid(d) ? format(d, dateFormat) : "";
};

const safeCvLangDateCell = (value: DateLike, cvLang: string): string => {
  if (value == null || value === "") return "";
  const d = new Date(value);
  if (!isValid(d)) return "";
  return cvLang === "en"
    ? format(d, "dd-MMM-yyyy")
    : d.toLocaleDateString("ar-SA", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
};

interface Props {
  currentEmployee: Employee;
  template: LabelTemplate;
  showHeader?: boolean | true;
  showPassportNumber?: boolean | true;
  showIssueDate?: boolean | true;
  showPlaceOfIssue?: boolean | true;
  showExpiryDate?: boolean | true;
}
export const BasicPassport = ({
  currentEmployee,
  template,
  showHeader,
  showPassportNumber,
  showIssueDate,
  showPlaceOfIssue,
  showExpiryDate,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            {showHeader && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "left",
                    width: "33%",
                  }}
                >
                  {tt("passport", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ width: "34%" }}
                ></StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                    width: "33%",
                  }}
                >
                  {tt("passport", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableHead>
          <TableBody>
            {showPassportNumber && (
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("passportNo", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.passportNumber as string}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("passportNumber", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showPlaceOfIssue && (
              <StyledTableRowTemplate template={template} key="2">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("placeOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.placeOfIssue as string}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("placeOfIssue", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showIssueDate && (
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {safeCvLangDateCell(
                    currentEmployee.passportIssueDate,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("dateOfIssue", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}

            {showExpiryDate && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfExpiry", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {safeCvLangDateCell(
                    currentEmployee.passportExpiryDate,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("dateOfExpiry", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicPassportGolden = ({
  currentEmployee,
  template,
  showHeader,
  showPassportNumber,
  showIssueDate,
  showPlaceOfIssue,
  showExpiryDate,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            {showHeader && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "left",
                    width: "33%",
                  }}
                >
                  {tt("passport", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ width: "34%" }}
                ></StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                    width: "33%",
                  }}
                >
                  {tt("passport", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableHead>
          <TableBody>
            {showPassportNumber && (
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("passportNo", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {currentEmployee.passportNumber as string}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("passportNumber", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}

            {showIssueDate && (
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {safeCvLangDateCell(
                    currentEmployee.passportIssueDate,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("dateOfIssue", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}

            {showExpiryDate && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfExpiry", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {safeCvLangDateCell(
                    currentEmployee.passportExpiryDate,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("dateOfExpiry", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showPlaceOfIssue && (
              <StyledTableRowTemplate template={template} key="2">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("placeOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {currentEmployee.placeOfIssue as string}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("placeOfIssue", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicPassportEnglish = ({
  currentEmployee,
  template,
  showHeader,
  showPassportNumber,
  showIssueDate,
  showPlaceOfIssue,
  showExpiryDate,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            {showHeader && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  template={template}
                  colSpan={2}
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {tt("passport", "en")}
                </StyledTableCellLabelTemplate>
                {/*<StyledTableCellLabelTemplate
                  template={template}
                  sx={{ width: "34%" }}
                ></StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                    width: "33%",
                  }}
                >
                  {tt("passport", "ar")}
                </StyledTableCellLabelTemplate> */}
              </StyledTableRowTemplate>
            )}
          </TableHead>
          <TableBody>
            {showPassportNumber && (
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("passportNo", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.passportNumber as string}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
            {showPlaceOfIssue && (
              <StyledTableRowTemplate template={template} key="2">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("placeOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.placeOfIssue as string}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
            {showIssueDate && (
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {safeFormatDate(
                    currentEmployee.passportIssueDate,
                    "dd-MMM-yyyy",
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}

            {showExpiryDate && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfExpiry", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {safeFormatDate(
                    currentEmployee.passportExpiryDate,
                    "dd-MMM-yyyy",
                  )}
                </StyledTableCellValueTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicPassportShort = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate
                template={template}
                colSpan={2}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("passport", "en")}
              </StyledTableCellLabelTemplate>

              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("passportDet", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="0">
              <StyledTableCellLabelTemplate template={template}>
                {tt("passportNo", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {currentEmployee.passportNumber as string}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("passportNumber", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>

            <StyledTableRowTemplate template={template} key="3">
              <StyledTableCellLabelTemplate template={template}>
                {tt("dateOfBirth", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {safeCvLangDateCell(
                  currentEmployee.dateOfBirth,
                  template.cvLang,
                )}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("dateOfBirth", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicPassportNoLabels = ({
  currentEmployee,
  template,
  showHeader,
  showPassportNumber,
  showIssueDate,
  showPlaceOfIssue,
  showExpiryDate,
}: Props) => {
  return (
    <>
      <StyledTableContainer
        template={template}
        sx={{
          marginTop: template.spacing,
        }}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            {showHeader && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "left",
                    width: "33%",
                  }}
                >
                  {tt("passport", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{ width: "34%" }}
                ></StyledTableCellLabelTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                    width: "33%",
                  }}
                >
                  {tt("passport", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableHead>
          <TableBody>
            {showPassportNumber && (
              <StyledTableRowTemplate template={template} key="0">
                <StyledTableCellLabelTemplate
                  template={template}
                ></StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate
                  template={template}
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {currentEmployee.passportNumber as string}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                ></StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showIssueDate && (
              <StyledTableRowTemplate template={template} key="1">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {safeCvLangDateCell(
                    currentEmployee.passportIssueDate,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("dateOfIssue", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showPlaceOfIssue && (
              <StyledTableRowTemplate template={template} key="2">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("placeOfIssue", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {currentEmployee.placeOfIssue as string}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("placeOfIssue", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
            {showExpiryDate && (
              <StyledTableRowTemplate template={template} key="3">
                <StyledTableCellLabelTemplate template={template}>
                  {tt("dateOfExpiry", "en")}
                </StyledTableCellLabelTemplate>
                <StyledTableCellValueTemplate template={template}>
                  {safeCvLangDateCell(
                    currentEmployee.passportExpiryDate,
                    template.cvLang,
                  )}
                </StyledTableCellValueTemplate>
                <StyledTableCellLabelTemplate
                  template={template}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {tt("dateOfExpiry", "ar")}
                </StyledTableCellLabelTemplate>
              </StyledTableRowTemplate>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
